/* eslint-disable */
const $ = window.jQuery = require('jquery');  
import toast from '@/services/toast';
export default {
  name: 'feedback-form',
  components: {},
  props: [],
  data () {
    return {
      ai_easily_navigable:'',
      explain_improve:'',
      how_to_use:'',
      feature_of_platform:'',
      submitted:false,
      alreadySubmittedForm:true,
      formSubmittedAfterMessage:true
    }
  },
  computed: {
  },
  created () {
    this.$store.dispatch('verifiedFeedbackUserFun', {id:this.$route.params.userId}).then((res) => {
      this.alreadySubmittedForm = true
    }).catch((err) => {
      if(err.status == '406'){
        this.alreadySubmittedForm = false
      }
    })
  },
  methods: {
    feedbackFormDataSubmit(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            ai_easily_navigable:this.ai_easily_navigable,
            explain_improve:this.explain_improve,
            how_to_use:this.how_to_use,
            feature_of_platform:this.feature_of_platform,
            user:this.$route.params.userId
          }
          this.$store.dispatch('userFeedbackSubmittedFun', data)
            .then((res) => {  
              toast.success(res.data.msg);
              this.ai_easily_navigable = ''
              this.explain_improve = ''
              this.how_to_use = ''
              this.feature_of_platform = ''
              this.submitted =  false
              this.formSubmittedAfterMessage = false
              this.$validator.reset()
            }).catch((err) => {
              if(err.status == '406'){
                this.submitted =  false
                this.alreadySubmittedForm = false
              }else{
                toast.error(err.data.msg);
                this.submitted =  false
              }
            })
          return;
        }
      })
    }

  },
  beforeCreate: function() {
    $('body').addClass('left_sidebaar_disabled_for_page')
    $('body').addClass('public_page_for_wrp_img')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('public_page_for_wrp_img')
    $(window).scrollTop(0);
    next();
  },
}